import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <defs>
      <path
        id="icons-eye_svg__a"
        d="M11.999 9a3.001 3.001 0 010 6 3 3 0 110-6zm5.467 6.535L21.002 12l-3.536-3.534a4.961 4.961 0 00-3.534-1.464H10.07a4.967 4.967 0 00-3.536 1.463L2.999 12l3.536 3.536A4.971 4.971 0 0010.07 17h3.86a5.029 5.029 0 003.535-1.465zm4.949-4.949c.78.78.78 2.05 0 2.828L18.88 16.95A7.042 7.042 0 0113.932 19H10.07a6.954 6.954 0 01-4.95-2.05l-3.535-3.536a2.001 2.001 0 010-2.828L5.12 7.05A6.95 6.95 0 0110.07 5l3.862.001c1.868 0 3.626.727 4.947 2.05l3.535 3.535z"
      />
    </defs>
    <use fill="currentColor" fillRule="evenodd" xlinkHref="#icons-eye_svg__a" />
  </svg>
);
